import type { ITheme, IStyle } from '@fluentui/style-utilities';
import type { JSXElement } from '@fluentui/utilities';

export interface IFloatingSuggestionsHeaderFooterProps {
  renderItem: () => JSXElement;
  onExecute?: () => void;
  className?: string;
  ariaLabel?: string;
  shouldShow: () => boolean;
}

export interface IFloatingSuggestionsHeaderFooterItemProps {
  renderItem: () => JSXElement;
  onExecute?: () => void;
  isSelected: boolean;
  id: string;
  className: string | undefined;
  theme?: ITheme;
}

export interface IFloatingSuggestionHeaderFooterItemStylesProps {}

export interface IFloatingSuggestionHeaderFooterItemStyles {
  actionButton: IStyle;
  buttonSelected: IStyle;
}
